export const categories = [
  {
    slug: 'domain-entry',
    name: '域名入口导航',
    description: '最新鲍鱼网址域名入口汇总，确保您随时找到正确的官方访问地址',
    icon: 'ri-global-line',
    color: 'primary',
  },
  {
    slug: 'security-access',
    name: '安全访问指南',
    description: '域名安全验证方法与防钓鱼技巧，保护您的账号信息安全',
    icon: 'ri-shield-check-line',
    color: 'accent',
  },
  {
    slug: 'register-login',
    name: '注册登录教程',
    description: '鲍鱼平台注册与登录全流程图文教程，新手快速上手',
    icon: 'ri-user-add-line',
    color: 'secondary',
  },
  {
    slug: 'domain-protection',
    name: '域名防丢失',
    description: '域名防失效方案与备用入口收藏方法，告别找不到地址的烦恼',
    icon: 'ri-bookmark-line',
    color: 'primary',
  },
];